export default {
  TableHead: [
    [
      {
        displayName: 'report.onlineuser.datatable.number',
      },
      {
        displayName: 'report.onlineuser.datatable.game',
      },
      {
        displayName: 'report.onlineuser.datatable.amount',
      },
    ],
  ],
};
